import styled from '@emotion/styled';
import { overlayColors } from '@revenuemarket/design';
import { Button } from 'antd';

export const ManageButton = styled(Button)`
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 32px;
  border: 1px solid ${overlayColors.white[16]};
`;
